import type { MouseEvent } from "react";
import styled from "styled-components";
import GreenCheck from "./icons/GreenCheck";
import RedClose from "./icons/RedClose";
import WhiteCheck from "./icons/WhiteCheck";
import WhiteClose from "./icons/WhiteClose";

export type IconTypes = "white-check" | "green-check" | "red-close" | "white-close";

export interface TagProps {
	background?: string;
	textColor?: string;
	text: string;
	className?: string;
	size?: "s" | "m" | "l";
	width?: string;
	height?: string;
	onClick?: (e: MouseEvent<HTMLDivElement>) => any;
	icon?: IconTypes;
	disabled?: boolean;
	getIcon?: Function;
}

const renderIcon = (icon: IconTypes) => {
	switch (icon) {
		case "white-check":
			return <WhiteCheck />;

		case "green-check":
			return <GreenCheck />;

		case "red-close":
			return <RedClose />;

		case "white-close":
			return <WhiteClose />;

		default:
			break;
	}
};

export const Tag: React.FC<TagProps> = ({
	text,
	className,
	textColor = "#fff",
	background = "#aaa",
	size = "m",
	width,
	height,
	onClick,
	icon,
	disabled,
}) => {
	return (
		<Styles
			background={background}
			textColor={textColor}
			className={`${className || ""} tag-size-${size} ${disabled ? "disabled" : ""} ${onClick ? "clickable" : ""}`}
			width={width || "auto"}
			height={height || "auto"}
			onClick={onClick}
		>
			{icon && <div className="icon">{renderIcon(icon)}</div>}

			{text}
		</Styles>
	);
};

const Styles = styled.div<{
	background: string;
	textColor: string;
	width: string;
	height: string;
}>`
	text-decoration: uppercase;
	font-weight: 500;
	padding: 3px 8px;
	letter-spacing: -0.4px;
	display: inline-block;
	border-radius: 2px;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;

	color: ${(props) => props.textColor};
	background-color: ${(props) => props.background};
	width: ${(props) => props.width};
	height: ${(props) => props.height};

	.icon {
		padding-right: 10px;
	}

	&.tag-size-l {
		font-size: 15px;
		padding: 6px 15px;
	}

	&.tag-size-s {
		font-size: 13px;
		padding: 4px 8px;
	}

	&.clickable {
		cursor: pointer;
	}

	&.disabled {
		background-color: #ccc;
		cursor: not-allowed;
		color: #a9a9a9;

		.icon {
			opacity: 0.5;
		}
	}
`;
